import { CHART_PALETTE, CHART_SPIDER_WEB } from '../../../utils/colors';

export const SPIDER_DEFAULT = {
  legendVisibility: true,
  titlesVisibility: true,
  rays: 31,
  values: 4,
  colors: CHART_PALETTE,
  webStroke: CHART_SPIDER_WEB,
  webStrokeWidth: 1,
  serieStrokeWidth: 2,
  margin: 15,
  fontSize: 12,
};
